import { useQuery } from 'react-query';

import { getCustomClusterList as queryFn } from 'api/endPoints/getCustomClusterList';
import { QueryKeys } from 'api/queryKeys';

export const useQueryClustersSearchWordsList = (params: QueryParams) => {
    return useQuery<QueryResponse[], QueryError, QueryResponse[], [QueryKeys, unknown]>({
        queryKey: ['clustersSearchWordsList', params],
        queryFn: () => queryFn(params),
        enabled: Boolean(params),
        staleTime: 300000,
    });
};

export type QueryParams = number | undefined;

interface QueryResponse {
    clusterName: string;
    id: number;
}
